import React from "react";

import "./styles.m.css";

const ElectionDownIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" styleName="wrapper">
      <path data-name="Path 132924" d="M0 0h22v22H0z" fill="none"/>
      <path data-name="Path 132925" d="M11 2a9 9 0 109 9 8.992 8.992 0 00-9-9zm0 16.2a7.2 7.2 0 117.2-7.2 7.21 7.21 0 01-7.2 7.2z" fill="#5f5f5f"/>
      <path data-name="Path 133471" d="M5.641 9.142a1.155 1.155 0 01.327-.8 1.137 1.137 0 011.6 0l3.429 3.418 3.431-3.435a1.133 1.133 0 011.6 1.6l-4.23 4.23a1.116 1.116 0 01-.8.327 1.165 1.165 0 01-.8-.327l-4.23-4.219a1.176 1.176 0 01-.327-.794z" fill="#707070"/>
    </svg>
  )
}

export default ElectionDownIcon;
